
import { Component, Vue, Watch } from "vue-property-decorator";

type Post = {
  id: number;
};

type PostMeta = {
  currentPage: number;
};

@Component({
  components: {
    Fab: () => import("@/app/modules/whiteboard/components/Fab.vue"),
    PostComponent: () => import("@/app/modules/whiteboard/components/PostComponent.vue")
  }
})
export default class PostsPage extends Vue {
  localLazyLoaded: boolean[] = [];
  perPage = 10;

  @Watch("localLazyLoaded")
  onLazyLoadedChanged() {
    this.lazyLoaded = [...this.localLazyLoaded];

    const trues = this.localLazyLoaded.filter(value => value);

    if (!this.isApiFetching && this.localLazyLoaded.length && trues.length % this.perPage == 0) {
      this.fetchPosts();
    }
  }

  get isApiFetching() {
    return this.$store.getters["api/isApiFetching"];
  }

  get postsData(): Post[] {
    return this.$store.getters["posts/data"];
  }

  get lazyLoaded(): boolean[] {
    return this.$store.getters["posts/lazyLoaded"];
  }

  set lazyLoaded(data: boolean[]) {
    this.$store.commit("posts/setLazyLoaded", [...data]);
  }

  get currentPage(): number {
    return this.$store.getters["posts/currentPage"];
  }

  set currentPage(page: number) {
    this.$store.commit("posts/setCurrentPage", page);
  }

  get lastPage(): number {
    return this.$store.getters["posts/lastPage"];
  }

  created() {
    this.$store.commit("posts/clearData");

    if (!this.postsData) this.fetchPosts();
    else this.localLazyLoaded = [...this.lazyLoaded];
  }

  fetchPosts() {
    if (this.lastPage && this.currentPage > this.lastPage) return;

    const meta: PostMeta = {
      currentPage: this.currentPage
    };

    this.$store.dispatch("posts/fetchAll", meta).then(({ data }) => {
      this.$store.commit("posts/setLastPage", data.meta.last_page);

      if (this.perPage != data.meta.per_page) this.perPage = data.meta.per_page;

      if (!this.postsData) this.$store.commit("posts/setData", [...data.data]);
      else this.$store.commit("posts/setData", [...this.postsData, ...data.data]);

      this.currentPage++;
    });
  }
}
